<script generics="T" lang="ts">
	import Checkbox from '../checkbox/Checkbox.svelte'
	import { type SelectOption } from './selectOption'
	import { _ } from '@repo/i18n'

	interface Props {
		options: SelectOption<T>[]
		values?: T[]
		onChange?: (values: T[]) => void
	}

	let { options, values = $bindable([]), onChange }: Props = $props()

	function handleChange(event: CustomEvent) {
		values = (event.detail ? options : disabledOptions).map((option) => option.value)
		onChange?.(values)
	}

	let disabledOptions = $derived(options.filter((option) => option.disabled))
	let allChecked = $derived(options.length === values?.length)
	let nothingChecked = $derived(disabledOptions.length === values?.length)
	let indeterminate = $derived(allChecked === nothingChecked)
</script>

<Checkbox
	class="w-full flex-1 p-3 text-sm"
	checked={allChecked}
	{indeterminate}
	label={$_('button.selectAll')}
	small
	on:change={handleChange}
/>

<div class="border-t border-t-gray-200 dark:border-t-gray-500"></div>
